import React from "react";
import PropTypes from "prop-types";
import CSSModules from "react-css-modules";

import onClickOutside from "react-onclickoutside";
import { isBotxoDomain } from "../../../utils/rebranding";

import DropdownMenu from "../DropdownMenu";

import styles from "./dropdown-button.cssmodule.scss";

const isPrevDomain = isBotxoDomain();

class DropdownButton extends React.Component {
  state = { open: false };

  onClick = () => {
    const { disabled } = this.props;
    if (!disabled) {
      this.setState(prevState => ({
        open: !prevState.open,
      }));
    }
  };

  onKeyPress = e => {
    if (e.key === "Enter") {
      this.onClick();
    }
  };

  onClickItem = data => {
    this.setState({
      open: false,
    });

    const { itemClick } = this.props;
    itemClick(data);
  };

  handleClickOutside = () => {
    this.setState({ open: false });
  };

  render() {
    const { menu, colour, altText, disabled } = this.props;
    const { open } = this.state;

    const composeDotStyleInline = {
      backgroundColor: colour,
    };

    const persistentMenuContainer = isPrevDomain
      ? styles.wrapper
      : styles.ndPersistentMenuContainer;
    const dotsContainer = isPrevDomain
      ? styles.dotsContainer
      : styles.ndDotsContainer;

    return (
      <div
        className={styles["dropdown-button-component"]}
        style={{ cursor: disabled ? "default" : "pointer" }}
        data-testid="dropdown"
      >
        {open && (
          <div
            id="persistent-menu-container"
            className={persistentMenuContainer}
          >
            <DropdownMenu menu={menu} itemClick={this.onClickItem} />
          </div>
        )}
        <div // eslint-disable-line
          onClick={this.onClick}
          onKeyPress={this.onKeyPress}
          className={dotsContainer}
          role="button"
          tabIndex={0}
          title={altText}
          aria-label={altText}
        >
          <div style={composeDotStyleInline} className={styles.dot} />
          <div style={composeDotStyleInline} className={styles.dot} />
          <div style={composeDotStyleInline} className={styles.dot} />
        </div>
      </div>
    );
  }
}

DropdownButton.propTypes = {
  ...DropdownMenu.propTypes,
  colour: PropTypes.string, // eslint-disable-line
  altText: PropTypes.string,
};
DropdownButton.defaultProps = {
  colour: "#ff004f", // eslint-disable-line
};

export default onClickOutside(CSSModules(DropdownButton, styles));
